<style scoped>

</style>
<template>
    <div class="bs-foundation admin-screen">

        <router-view></router-view>

    </div>
</template>
<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        name: "AdminLayout",
        components: {

        },
        data() {
            return {

            }
        },
        created: function () {
            var self = this;

        },
        mounted() {
            var self = this;

        },
        updated: function () {
            var self = this;

        },
        computed: {
            ...mapState([
                "currentUser",
            ])
        },
        methods: {

        }
    }
</script>
<style scoped>
.admin-screen { width: calc(100% - 2rem); max-width: 1127px; margin: 0 auto; }
</style>
